import { FilterGroupRequest, FilterRequestMap } from 'components/filter/types';
import { BulkActionResource, BulkActionStatus } from 'constants/bulkActions';

const injectResourceFilter = (
    resource: BulkActionResource[],
): FilterGroupRequest<FilterRequestMap>[] => {
    return [
        {
            type: 'and',
            children: {
                resource: [
                    {
                        value: resource,
                        operator: 'any',
                        type: 'and',
                    },
                ],
            },
        },
    ];
};

const injectStatusFilter = (status: BulkActionStatus[]): FilterGroupRequest<FilterRequestMap>[] => {
    return [
        {
            type: 'and',
            children: {
                status: [
                    {
                        value: status,
                        operator: 'any',
                        type: 'and',
                    },
                ],
            },
        },
    ];
};

export { injectResourceFilter, injectStatusFilter };
